<!-- eslint-disable vue/no-bare-strings-in-template -->
<script>
import ContactAPI from 'dashboard/api/contacts';

const DISPLAY_FIELDS = [
  ['name', 'Nome'],
  ['document_type', 'Tipo de documento'],
  ['document', 'Documento'],
  ['email', 'E-mail'],
  ['phone', 'Telefone'],
  ['whatsapp', 'WhatsApp'],
  ['instagram', 'Instagram'],
  ['tiktok', 'TikTok'],
  ['facebook', 'Facebook'],
  ['telegram', 'Telegram'],
  ['twitter', 'X/Twitter'],
  ['linkedin', 'LinkedIn'],
  ['birth_date', 'Data de nascimento'],
  ['address', 'Endereço'],
  ['address_number', 'Número'],
  ['address_complement', 'Complemento'],
  ['neighborhood', 'Bairro'],
  ['city', 'Cidade'],
  ['state', 'Estado'],
  ['zip_code', 'CEP'],
  ['status', 'Status'],
  ['categoria', 'Categoria'],
  ['categoria_abc', 'Curva ABC'],
  ['origem', 'Origem'],
  ['data_ultima_compra', 'Última compra'],
  ['valor_total_compras', 'Total de compras'],
  ['notes', 'Observações'],
  ['responsible', 'Vendedor responsável'],
  ['photo_url', 'Foto do cliente'],
];

export default {
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['loaded'],
  data() {
    return {
      client: null,
      isLoading: false,
      hasError: false,
    };
  },
  computed: {
    displayFields() {
      const display = this.client?.display || {};

      return DISPLAY_FIELDS.map(([key, label]) => ({
        key,
        label,
        value:
          key === 'photo_url' ? (display[key] ? 'Cadastrada' : '') : display[key],
      })).filter(
        field =>
          field.value !== null &&
          field.value !== undefined &&
          `${field.value}`.trim() !== ''
      );
    },
  },
  watch: {
    'contact.id': {
      handler() {
        this.loadClient();
      },
      immediate: true,
    },
  },
  methods: {
    async loadClient() {
      if (!this.contact?.id) return;

      this.isLoading = true;
      this.hasError = false;
      try {
        const { data } = await ContactAPI.getAceleresClient(this.contact.id);
        this.client = data?.data || null;
        this.$emit('loaded', this.client);
      } catch (error) {
        this.client = null;
        this.hasError = true;
        this.$emit('loaded', null);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <section class="aceleres-client-details" aria-label="Detalhes cadastrais">
    <div v-if="isLoading" class="aceleres-client-details__state">
      <span class="i-lucide-loader-circle aceleres-client-details__spinner" />
      <span>Carregando dados da Base de Clientes...</span>
    </div>
    <div v-else-if="hasError" class="aceleres-client-details__state">
      Não foi possível carregar os dados cadastrais agora.
    </div>
    <div v-else-if="!client" class="aceleres-client-details__state">
      Este contato ainda não está vinculado à Base de Clientes.
    </div>
    <template v-else>
      <div class="aceleres-client-details__header">
        <div>
          <h3>Dados cadastrais</h3>
          <p>Informações sincronizadas com a Base de Clientes da Acelerity.</p>
        </div>
        <span class="aceleres-client-details__responsible">
          Responsável:
          {{ client.responsible || client.seller || 'Não definido' }}
        </span>
      </div>

      <img
        v-if="client.display?.photo_url"
        :src="client.display.photo_url"
        alt="Foto do cliente"
        class="aceleres-client-details__photo"
      />

      <div class="aceleres-client-details__grid">
        <article
          v-for="field in displayFields"
          :key="field.key"
          class="aceleres-client-details__card"
        >
          <span class="aceleres-client-details__label">{{ field.label }}</span>
          <span class="aceleres-client-details__value">{{ field.value }}</span>
        </article>
      </div>
    </template>
  </section>
</template>

<style scoped>
.aceleres-client-details {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
}
.aceleres-client-details__state {
  padding: 28px 8px;
  color: rgb(var(--slate-11));
  text-align: center;
}
.aceleres-client-details__spinner {
  display: inline-block;
  margin-right: 8px;
  animation: aceleres-client-spin 1s linear infinite;
}
.aceleres-client-details__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.aceleres-client-details__header h3 {
  margin: 0;
  color: rgb(var(--slate-12));
  font-size: 18px;
  font-weight: 600;
}
.aceleres-client-details__header p {
  margin: 4px 0 0;
  color: rgb(var(--slate-10));
  font-size: 13px;
}
.aceleres-client-details__responsible {
  flex-shrink: 0;
  color: rgb(var(--slate-11));
  font-size: 13px;
}
.aceleres-client-details__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.aceleres-client-details__photo {
  width: 72px;
  height: 72px;
  border-radius: 9999px;
  object-fit: cover;
}
.aceleres-client-details__card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  border: 1px solid rgb(var(--border-weak));
  border-radius: 10px;
  background: rgb(var(--slate-2));
}
.aceleres-client-details__label {
  color: rgb(var(--slate-10));
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.aceleres-client-details__value {
  overflow-wrap: anywhere;
  color: rgb(var(--slate-12));
  font-size: 14px;
  white-space: pre-wrap;
}
@keyframes aceleres-client-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 640px) {
  .aceleres-client-details__header {
    flex-direction: column;
  }
  .aceleres-client-details__grid {
    grid-template-columns: 1fr;
  }
}
</style>
